import React from 'react';

import { PageGridItem } from 'corgi/common/components/PageGrid';
import RecommendationsSlider from 'corgi/recommendations-slider/components/RecommendationsSlider';
import ShopTheLookComponent from 'corgi/shop-the-look/ShopTheLook';
import type { ShopTheLookProps } from 'corgi/shop-the-look/types';

import type { LayoutProps } from '@local-types/content/layout';
import { arePropsNonEmpty } from '@utils/render';
import { getSliceStyles } from '../Slices/styles';

const ShopTheLook = ({ layoutProps }: { layoutProps: LayoutProps }) => {
  const shopTheLookProps = layoutProps['shop-the-look'];
  const recoSliderProps = layoutProps['recommendations-slider'];

  const withShopTheLook = arePropsNonEmpty(shopTheLookProps);
  const withRecoSlider = arePropsNonEmpty(recoSliderProps);

  return (
    <PageGridItem display="flex" flexDirection="column" width={1}>
      {withShopTheLook && (
        <PageGridItem width={1} mb={['sp_16', 'sp_20', 'sp_24', 'sp_32']}>
          <ShopTheLookComponent {...(shopTheLookProps as ShopTheLookProps)} />
        </PageGridItem>
      )}
      <PageGridItem {...getSliceStyles('recommendations-slider')}>
        {withRecoSlider && <RecommendationsSlider {...recoSliderProps} />}
      </PageGridItem>
    </PageGridItem>
  );
};

export default ShopTheLook;
